<template>
  <div>
    <!-- <b-nav align="right" class="wrap-change-region">
      <b-nav-item class="text-12 mr-md-8 change-region" v-b-toggle.sidebar-right
        >Region｜{{ $t(provinceName) }}</b-nav-item
      >
    </b-nav> -->
    <b-navbar class="navbar shadow-sm">
      <b-navbar-brand href="#" class="py-2 mr-2" style="padding-right: 20px">
        <img
          class="logo img-fluid"
          width="103"
          v-i18n-src="'@/assets/img/locales/{locale}/logo/logo.png'"
          @click="$router.push('/')"
        />
      </b-navbar-brand>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="!device.isMobile">
          <b-nav-item
            v-for="tab of tabs"
            :key="tab.key"
            :to="tab.to"
            :class="tab.class"
          >
            <div
              v-if="!tab.isHidden"
              class="left-title"
              :class="{active: isActive(tab)}"
            >
              {{ tab.title }}
            </div>
          </b-nav-item>
        </b-navbar-nav>

        <div v-if="isLogin" class="ml-auto d-flex align-items-center">
          <b-navbar-nav>
            <b-nav-item-dropdown
              :menu-class="[
                'notification-wrapper scroll-bar',
                notifications.length === 0 ? 'p-0' : 'p-5',
              ]"
              class="notification-dropdown mr-3"
              right
              @hidden="updateNotifications"
            >
              <template #button-content>
                <b-avatar class="avatar position-relative" variant="white">
                  <div v-if="hasNotification" class="notification-dot"></div>
                  <b-icon-bell-fill
                    :class="{'text-primary': hasNotification}"
                  ></b-icon-bell-fill>
                </b-avatar>
              </template>
              <EmptyPlaceholder
                v-if="notifications.length === 0"
                :style="device.isMobile ? '' : 'width: 320px'"
                :hasBorder="false"
              ></EmptyPlaceholder>

              <template v-else>
                <NotificationCard
                  v-for="notification in notifications"
                  :key="notification.id"
                  :notification="notification"
                  @updateNotification="updateNotifications"
              /></template>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown class="action-wrapper" right>
              <template #button-content>
                <b-avatar class="avatar" variant="white">
                  <b-icon v-if="device.isMobile" icon="list"></b-icon>
                  <span v-else>{{ name }}</span>
                  <div
                    v-if="!hasViewRankSetting && !hasRanks"
                    class="notification-dot"
                  ></div>
                </b-avatar>
              </template>
              <template v-for="item in dropdownItems">
                <b-dropdown-item
                  v-if="!item.isHidden"
                  class="p-0"
                  :href="item.href"
                  :key="item.value"
                  :target="item.target"
                  @click="onClickItems(item.value)"
                >
                  <b-button block pill v-if="item.isButton">{{
                    item.title
                  }}</b-button>
                  <span v-else style="position: relative">
                    {{ item.title }}
                  </span>
                  <div v-if="item.hasDot" class="notification-dot"></div>
                </b-dropdown-item>
                <hr class="m-2" :key="item.value + 'hr'" v-if="item.hr" />
              </template>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </div>
        <div
          v-else
          class="ml-auto mr-4 mr-md-6 login d-flex align-items-center"
        >
          <b-navbar-nav
            class="ml-4 cursor-pointer"
            style="flex-shrink: 0"
            @click="showLoginModal"
          >
            {{ $t('登入／註冊') }}
          </b-navbar-nav>
        </div>
      </b-collapse>
    </b-navbar>
    <b-sidebar
      id="sidebar-right"
      header-class="region-list-header"
      title=""
      right
      backdrop-variant="dark"
      backdrop
      shadow
    >
      <div class="px-3 py-2">
        <ul class="list-unstyled wrap-region-list">
          <li
            v-for="_province in provinceOptions"
            :key="_province.id"
            class="mb-3 py-3 px-6"
            :class="{active: _province.id === province}"
            @click="changeProvince(_province)"
          >
            {{ $t(PROVINCE[_province.id]?.label) }}
          </li>
        </ul>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import NotificationCard from '@/components/Notification/NotificationCard.vue';
import notificationService from '@/services/notification.js';
import EmptyPlaceholder from '@/components/Common/EmptyPlaceholder.vue';
import {manifest} from '@/constant/env.js';
import {saveLocalData} from '@/lib/base/localData';
import {PROVINCE} from '@/constant/province.js';
import {POPUP_RECORD_TYPES} from '@/constant/popupRecord.js';
import {isUnofficialRankType} from '@/lib/base/ranking.js';

/* eslint-disable indent */
export default {
  components: {NotificationCard, EmptyPlaceholder},
  data() {
    return {
      active: 'home',
      limit: 10,
      notifications: [],
      province: null,
      provinceName: null,
      PROVINCE,
    };
  },
  watch: {
    $route: {
      handler() {
        if (this.$route?.name) {
          if (this.$route.matched[1]) {
            this.active = this.$route.matched[1].name;
          } else {
            this.active = this.$route.matched[0].name;
          }
        }
      },
      immediate: true,
    },
    userData: {
      handler(newValue) {
        if (Object.keys(newValue).length > 0) {
          this.getNotification();
          this.getPopupRecords();
        }
      },
      immediate: true,
    },
  },
  computed: {
    device() {
      return this.$store.getters['env/device'];
    },
    isLogin() {
      return this.$store.state.auth.isLogin;
    },
    userData() {
      return this.$store.state.auth.userData;
    },
    requireAuth() {
      return this.$route.matched.some((route) => route.meta.requireAuth);
    },
    name() {
      return this.isLogin
        ? this.$store.state.auth.userData?.name?.charAt(0)
        : '测';
    },
    currentPermission() {
      return this.$store.getters['auth/currentPermission'];
    },
    routePermission() {
      return this.currentPermission.route;
    },
    hasNotification() {
      return this.notifications.some((notification) => !notification.isClick);
    },
    hasViewRankSetting() {
      if (!this.isLogin) return true;
      return this.$store.getters['popupRecord/getIsDone'](
        POPUP_RECORD_TYPES.HAS_VIEW_RANK_SETTING
      );
    },
    rankTypes() {
      return this.$store.getters['province/rankTypes'];
    },
    hasRanks() {
      const ranks = this.userData?.ranks;
      if (ranks) {
        const checkRanks = this.rankTypes.filter(
          (type) => !isUnofficialRankType(type)
        );
        return ranks.some(
          ({rank, type}) => rank > 0 && checkRanks.includes(type)
        );
      }
      return true;
    },
    dropdownItems() {
      return this.device.isMobile
        ? this.dropdownItemsMobile
        : this.dropdownItemsDesktop;
    },
    dropdownItemsDesktop() {
      return [
        {
          title: this.$t('個人資訊'),
          value: 'personal',
        },
        {
          title: this.$t('設定'),
          value: 'setting',
          hasDot: !this.hasViewRankSetting && !this.hasRanks,
        },
        {
          title: this.$t('管理後台'),
          value: 'backstage',
          isHidden: !this.routePermission?.backstage,
          href: !this.device.isMobile ? manifest.backstage : '',
          target: '_blank',
        },
        {
          title: this.$t('登出'),
          value: 'logout',
        },
      ];
    },
    dropdownItemsMobile() {
      return [
        {
          key: 'start-exam',
          title: this.$t('開始檢定'),
          isHidden: (this.todayExams || []).length === 0,
          value: 'start-exam',
          isButton: true,
        },
        {
          title: this.$t('檢定報到掃碼'),
          value: 'exam-verify',
          isHidden: !(this.userData.permissions || []).includes('ACTIVE_EXAM'),
          hr: true,
        },
        {
          key: 'home',
          title: this.$t('首頁'),
          value: 'home-page',
        },
        {
          key: 'exam-list-index',
          title: this.$t('報名檢定'),
          value: 'exam-list-index',
        },
        {
          key: 'tournament-list-index',
          title: this.$t('報名比賽'),
          value: 'tournament-list-index',
          hr: true,
        },
        {
          title: this.$t('個人資訊'),
          value: 'personal',
        },
        {
          title: this.$t('設定'),
          value: 'setting',
          hasDot: !this.hasViewRankSetting && !this.hasRanks,
        },

        {
          title: this.$t('關於IGQE'),
          value: 'introduction',
        },
        {
          title: this.$t('常見問答'),
          value: 'faqs',
        },
        {
          title: this.$t('聯絡我們'),
          value: 'contact',
          hr: true,
        },

        {
          title: this.$t('登出'),
          value: 'logout',
        },
      ];
    },
    currentExams() {
      return this.$store.state.exam.currentExams;
    },
    todayExams() {
      const currentExams = this.$store.state.exam.currentExams;
      return currentExams.filter(
        (exam) =>
          this.$day().isBetween(
            this.$day(exam?.groupStartAt).startOf('day'),
            this.$day(exam?.groupEndedAt),
            'minute'
          ) && ![2, 3, 4].includes(exam?.group?.status)
      );
    },
    tabs() {
      return [
        {
          key: 'home',
          title: this.$t('首頁'),
          to: {
            name: 'home-page',
          },
        },
        {
          key: 'exam-list-index',
          title: this.$t('報名檢定'),
          to: {
            name: 'exam-list-index',
            params: {
              pagination: 1,
            },
          },
        },
        {
          key: 'tournament-list-index',
          title: this.$t('報名比賽'),
          to: {
            name: 'tournament-list-index',
            params: {
              pagination: 1,
            },
          },
        },
        {
          key: 'start-exam',
          title: this.$t('開始檢定'),
          class: 'start-exam',
          isHidden: (this.todayExams || []).length === 0,
          to: {
            name: 'personal',
            query: {
              state: 'exam',
            },
          },
        },
      ];
    },
    provinceOptions() {
      const provinces = [];
      const result = this.$store.getters['province/province'];
      provinces.push(...result);
      return provinces;
    },
  },
  created() {
    const provinceId = this.$getProvinceId();
    this.changeProvince({
      id: provinceId,
      name: PROVINCE[provinceId]?.label,
      code: PROVINCE[provinceId]?.value,
    });
    this.$store.commit('env/setCurrency', PROVINCE[this.province].currency);
  },
  methods: {
    async getNotification() {
      if (!this.isLogin) {
        return;
      }
      const params = {
        limit: this.limit,
        offset: 0,
        userId: this.userData.id,
        website: 'IGQE',
      };

      const result = await notificationService.getNotifications(params);
      this.notifications = result.rows;
    },
    async getPopupRecords() {
      if (!this.isLogin) {
        return;
      }
      const types = [POPUP_RECORD_TYPES.HAS_VIEW_RANK_SETTING];
      await this.$store.dispatch('popupRecord/getIsDone', types);
    },
    onClickItems(value) {
      switch (value) {
        case 'logout':
          this.logout();
          break;
        case 'personal':
          return this.$router.push({
            name: 'personal-index',
          });
        case 'exam-verify':
          return this.$router.push({
            name: 'exam-verify',
          });
        case 'setting':
          return this.$router.push({
            name: 'setting',
            query: {
              state: 'info-setting',
            },
          });
        case 'backstage':
          if (this.device.isMobile) {
            this.$Message.info(this.$t('請使用電腦/平版開啟後台'));
          }
          break;
        case 'faqs':
          return this.$router.push({
            name: 'faqs',
          });
        case 'start-exam':
          return this.$router.push({
            name: 'personal',
            query: {
              state: 'exam',
            },
          });
        case 'contact':
          window.open(manifest.report);
          break;
        case 'home-page':
          return this.$router.push({
            name: 'home-page',
          });
        case 'exam-list-index':
          return this.$router.push({
            name: 'exam-list-index',
            params: {
              pagination: 1,
            },
          });
        case 'tournament-list-index':
          return this.$router.push({
            name: 'tournament-list-index',
            params: {
              pagination: 1,
            },
          });
        case 'introduction':
          return this.$router.push({
            name: 'introduction',
          });
        default:
          break;
      }
    },
    updateNotifications() {
      if (this.hasNotification) {
        for (let index = 0; index < this.notifications.length; index++) {
          this.updateNotification(this.notifications[index]);
        }
      }
    },
    async updateNotification(notification) {
      const index = this.notifications.findIndex(
        (data) => data.id === notification.id
      );
      this.$set(this.notifications[index], 'isClick', true);
      await notificationService.updateNotifications(notification.id, {
        isClick: true,
      });
    },
    showLoginModal() {
      this.$store.commit('env/setLoginModalShow', true);
    },
    isActive(tab) {
      return this.active.includes(tab.key);
    },
    logout() {
      this.$store.dispatch('auth/logout');
      if (this.userData?.id == null && this.requireAuth) {
        this.$router.push({name: 'home'});
      }
    },
    changeProvince({id, name, code}) {
      this.province = id;
      this.provinceName = name;
      saveLocalData('provinceId', parseInt(id));
      this.redirectToProvinceUrl(code);
      this.$i18n.locale = code;
    },
    redirectToProvinceUrl(code) {
      if (!code) return;
      const url = new URL(window.location.href);
      url.pathname = `/${code}/`;
      location.href = url.href;
    },
  },
};
</script>
<style lang="scss">
.wrap-change-region {
  background: #7db9de26;
  .change-region .nav-link {
    color: #345f80;
    &:hover {
      color: $secondary;
    }
  }
}
.b-sidebar > .region-list-header {
  padding: 12px !important;
  .close {
    margin-left: auto;
    margin-right: 0 !important;
    font-size: 36px !important;
    color: $gray-700 !important;
    opacity: 1;
  }
}
.wrap-region-list {
  line-height: 24px;
  li {
    cursor: pointer;
    color: #212529;
    &:hover {
      color: $secondary;
    }
    &.active {
      color: $secondary;
    }
  }
}

.navbar {
  background: #fff;
  position: fixed;
  z-index: 100;
  padding: 8px 40px !important;
  @media screen and (max-width: 768px) {
    padding: 8px 16px !important;
    z-index: 100 !important;
  }

  &.navbar-expand .navbar-nav .dropdown-menu.notification-wrapper {
    max-height: 400px;
    overflow-y: overlay;
    @media screen and (max-width: 768px) {
      position: fixed;
      top: 58px;
      right: 0;
      left: 0;
      max-height: calc(
        100vh - 58px - env(safe-area-inset-bottom) - evn(safe-area-inset-top)
      );
    }
  }

  .notification-dot {
    width: 12px;
    height: 12px;
    top: 0px;
    right: 0px;
    border-radius: 50%;
    background: $red;
    position: absolute;
  }
  ::v-deep .wrap-search-empty {
    border-radius: 0px 0px 24px 24px;
  }
  .avatar {
    font-size: 14px;
    background: white;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: $gray-700;
    border: 1px solid $gray-400;
    &:hover {
      background: #ebebeb;
    }
  }
  .nav-link {
    outline: none;
  }
  .dropdown-menu {
    border: 1px solid $gray-200;
    border-radius: 0px 0px 24px 24px;
    min-width: 192px;
    margin: 0;
    top: calc(100% + 11px);
    overflow: hidden;
    padding: 8px 0px 5px 0px;
    @media screen and (max-width: 768px) {
      min-width: 100vw;
      max-width: 100vw;
      border-radius: 0;
      border: 1px solid var(--Components-Card-border, #dfdfdf);
      height: calc(
        100vh - 58px - env(safe-area-inset-bottom) - evn(safe-area-inset-top)
      );
      padding: 8px 16px 5px 16px;
    }
  }
  .action-wrapper {
    .dropdown-menu {
      background: $gray-100;
      border: 1px solid #dfdfdf;
      right: 0;
      @media screen and (max-width: 768px) {
        right: -16px;
      }
    }

    .dropdown-item {
      padding: 0.5rem 1.5rem;
    }
  }
  .start-exam {
    background: $secondary;
    border-radius: 24px;
    .left-title {
      color: $white;
    }
  }

  .dropdown-toggle::after {
    display: none;
  }
  .navbar-expand {
    display: none;
  }

  .navbar-nav .nav-link {
    padding: 0 !important;
  }
  .login {
    color: $gray-700;
  }

  .left-title {
    color: $gray-800;
    padding: 8px 16px;
    line-height: 26px;
    &.active {
      color: $primary;
      font-weight: 700;
    }
  }
  .b-avatar-custom {
    border-radius: initial !important;
  }
  .dropdown-item {
    position: relative;
    .notification-dot {
      top: calc(50% - 6px);
      right: 24px;
    }
  }
}
</style>
